export enum PushNotificationIconName {
  PushBellowYellow = 'PushBellowYellow',
  PushSale = 'PushSale',
  PushBellRed = 'PushBellRed',
  PushTruck = 'PushTruck',
  Truck = 'Truck',
  Gift = 'Gift',
  UspAuthenticityCheck = 'UspAuthenticityCheck',
  PushBellBadge = 'PushBellBadge',
}

export const pushNotificationIconAssets: {
  [key in PushNotificationIconName]: string;
} = {
  [PushNotificationIconName.PushBellowYellow]: require('./il-push-bell-yellow.svg'),
  [PushNotificationIconName.PushSale]: require('./il-push-sale.svg'),
  [PushNotificationIconName.PushBellRed]: require('./il-push-bell-red.svg'),
  [PushNotificationIconName.PushTruck]: require('./il-push-truck.svg'),
  [PushNotificationIconName.Truck]: require('./ic-truck.svg'),
  [PushNotificationIconName.Gift]: require('./ic-gift.svg'),
  [PushNotificationIconName.UspAuthenticityCheck]: require('./ic-usp-authenticy-check.svg'),
  [PushNotificationIconName.PushBellBadge]: require('./ic-push-bell-badge.svg'),
};
